import React, { useState, useEffect } from "react";
import {
  black,
  primary500,
} from "../../lib/rebrandColors/colors";
import { useLocation } from "react-router-dom";
import "../../App.css"; // Import your fonts
import TextButton from "../textButton";
import { CircularProgress, } from "@mui/material";
import ApplianceTypeList from "../applianceTypeList";
import { adjustOutlets } from "../../functions/outlets";
import CustomIcon from "../icon";
import ApplianceDetailsScreen from "../applianceDetails";
import OutletCard from "../outletCard";
import Dropdown from "../dropDown";
import IconButton from "../iconButton";
import TextField from "../textField";

export default function OutletList({
  layoutProps,
  width,
  height,
  buildingOutlets,
  buildingID = null,
}) {
  const location = useLocation();
  const [filter, setFilter] = useState(true);
  const [filterLoading, setFilterLoading] = useState(true);
  const [filteredOutlets, setFilteredOutlets] = useState(() => {
    if (Array.isArray(buildingOutlets) && buildingOutlets.length > 0) {
      return layoutProps.outlets.filter((item) => buildingOutlets.includes(item.id));
    }
    return layoutProps.outlets;
  });
  const [orderedOutlets, setOrderedOutlets] = useState(() => {
    if (Array.isArray(buildingOutlets) && buildingOutlets.length > 0) {
      return layoutProps.outlets.filter((item) => buildingOutlets.includes(item.id));
    }
    return layoutProps.outlets;
  });
  // const [filteredOutlets, setFilteredOutlets] = useState(layoutProps.outlets || buildingOutlets);
  // const [orderedOutlets, setOrderedOutlets] = useState(layoutProps.outlets || buildingOutlets);
  const [currentOutlet, setCurrentOutlet] = useState({});
  const [index, setIndex] = useState();
  const [displayExtra, setDisplayExtra] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(location.state?.updateTab ? 1 : (location.pathname === '/' && !displayExtra) ? 0 : 1);
  const [outletListFilter, setOutletListFilter] = useState('Savings');
  const [outletListDropdownOpen, setOutletListDropdownOpen] = useState(false);
  const [applianceTypeFilter, setApplianceTypeFilter] = useState('Savings');
  const [applianceTypeFilterDropdown, setApplianceTypeFilterDropdown] = useState(false);
  const [filterDirection, setFilterDirection] = useState('Desc');
  const [searchTerm, setSearchTerm] = useState('');

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const closeModal = () => setIsModalOpen(false);

  // convert to a "modal", should be whole screen, display appliance details
  const handleRowClick = (outlet, i) => {
    setIndex(i);
    setCurrentOutlet(outlet);
    setIsModalOpen(true);
  };
  const selectOutletFilterPress = (option) => {
    setOutletListFilter(option);
  };
  const selectApplianceFilterPress = (option) => {
    setApplianceTypeFilter(option);
  };
  const handleSearchTermChange = (value) => {
    const newTerm = value;
    setSearchTerm(newTerm);
  };

  useEffect(() => {
    let displayOutlets = layoutProps.outlets;

    if (buildingOutlets && buildingOutlets.length > 0) {
      displayOutlets = layoutProps.outlets.filter(
        (item) => buildingOutlets.includes(item.id)
      );
      setDisplayExtra(true);
      setSelectedTab(1);
    } else if (buildingID) {
      displayOutlets = [];
    };
    adjustOutlets(
      layoutProps.timezone,
      layoutProps.wattHours,
      layoutProps.savings,
      displayOutlets,
      layoutProps.orgData,
      setFilteredOutlets,
      filter,
      setFilterLoading,
    );
  }, [layoutProps.outletsLoading, layoutProps.orgData, layoutProps.timezone, layoutProps.outlets, buildingOutlets]);

  useEffect(() => {
    let sorted = layoutProps.outlets;

    if (buildingOutlets && buildingOutlets.length > 0) {
      sorted = layoutProps.outlets.filter(
        (item) => buildingOutlets.includes(item.id)
      );
    };

    if (outletListFilter === 'Name' && filterDirection === 'Desc') {
      sorted = [...filteredOutlets].sort((a, b) => {
        const nameA = a.name.toLowerCase(); // to ensure case-insensitive sorting
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });

    } else if (outletListFilter === 'Name' && filterDirection === 'Asc') {
      sorted = [...filteredOutlets].sort((a, b) => {
        const nameA = a.name.toLowerCase(); // to ensure case-insensitive sorting
        const nameB = b.name.toLowerCase();
        if (nameB < nameA) return -1;
        if (nameB > nameA) return 1;
        return 0;
      });

    } else if (outletListFilter === 'Savings' && filterDirection === 'Desc') {
      sorted = [...filteredOutlets].sort((a, b) => b.costSavings - a.costSavings)
    } else if (outletListFilter === 'Savings' && filterDirection === 'Asc') {
      sorted = [...filteredOutlets].sort((a, b) => a.costSavings - b.costSavings)
    } else if (outletListFilter === 'WiFi Status' && filterDirection === 'Desc') {
      const statusPriority = {
        connected: 0,
        disconnected: 1,
        'not activated': 2, // lowercase
      };

      sorted = [...filteredOutlets].sort((a, b) => {
        const aPriority = statusPriority[a.wifiStatus?.toLowerCase()] ?? 999;
        const bPriority = statusPriority[b.wifiStatus?.toLowerCase()] ?? 999;
        return aPriority - bPriority;
      });
    } else if (outletListFilter === 'WiFi Status' && filterDirection === 'Asc') {
      const statusPriority = {
        connected: 0,
        disconnected: 1,
        'not activated': 2, // lowercase
      };
      sorted = [...filteredOutlets].sort((a, b) => {
        const aPriority = statusPriority[a.wifiStatus?.toLowerCase()] ?? 999;
        const bPriority = statusPriority[b.wifiStatus?.toLowerCase()] ?? 999;
        return bPriority - aPriority;
      });
    } else if (outletListFilter === 'On/Off Status' && filterDirection === 'Desc') {
      const statusPriority = {
        On: 0,
        Off: 1,
      };
      sorted = [...filteredOutlets].sort((a, b) => {
        const aPriority = statusPriority[a.status] ?? 999;
        const bPriority = statusPriority[b.status] ?? 999;
        return aPriority - bPriority;
      });
    } else if (outletListFilter === 'On/Off Status' && filterDirection === 'Asc') {
      const statusPriority = {
        On: 0,
        Off: 1,
      };
      sorted = [...filteredOutlets].sort((a, b) => {
        const aPriority = statusPriority[a.status] ?? 999;
        const bPriority = statusPriority[b.status] ?? 999;
        return bPriority - aPriority;
      });
    } else if (outletListFilter === 'Appliance Type' && filterDirection === 'Desc') {
      sorted = [...filteredOutlets].sort((a, b) => {
        const prodA = a.productType.toLowerCase(); // to ensure case-insensitive sorting
        const prodB = b.productType.toLowerCase();
        if (prodA < prodB) return -1;
        if (prodA > prodB) return 1;
        return 0;
      });
    } else if (outletListFilter === 'Appliance Type' && filterDirection === 'Asc') {
      sorted = [...filteredOutlets].sort((a, b) => {
        const prodA = a.productType.toLowerCase(); // to ensure case-insensitive sorting
        const prodB = b.productType.toLowerCase();
        if (prodB < prodA) return -1;
        if (prodB > prodA) return 1;
        return 0;
      });
    };

    if (searchTerm?.length > 0) {
      // Convert searchTerm to lowercase for case-insensitive search
      const term = searchTerm.toLowerCase();

      sorted = sorted.filter(outlet =>
        outlet.device?.toLowerCase().includes(term) ||
        outlet.name?.toLowerCase().includes(term) ||
        outlet.productType?.toLowerCase().includes(term)
      );
    };
    
    setOrderedOutlets(sorted);

  }, [layoutProps.outlets, outletListFilter, filterDirection, searchTerm, filteredOutlets]);

  return (
    <>
      <div style={{
        margin: ".5%",
        minWidth: "500px",
        borderRadius: "24px",
        minHeight: "824px",
        width: '100%',
      }}>
        {/* header for dashboard */}
        {(location.pathname === '/' && !displayExtra) &&
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '39px',
            marginTop: '28px',
          }}>
            <CustomIcon
              name="plug"
              color={black}
              size={30}
            />
            <div
              className="bodyLarge"
              style={{
                marginLeft: '8px',
              }}
            >
              Appliances
            </div>
          </div>
        }
        <div style={{
          display: 'flex',
          justifyContent: (location.pathname === '/' && !displayExtra) ? 'center' : 'space-between',
          width: '95%',
        }}>
          {/* tab bar */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            width: "90%",
            marginTop: (location.pathname === '/') ? '10px' : '20px',
            marginBottom: '10px',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              // width: width ? width : "480px",
            }}>
              {buildingID !== 'placeholder' &&
                <TextButton
                  label='Appliance type'
                  underlined={true}
                  onPress={() => handleTabChange(0)}
                  fill={selectedTab == 0 && primary500}
                />
              }
              <div style={{ marginLeft: '10px' }}>
                <TextButton
                  label='Individual appliances'
                  underlined={true}
                  onPress={() => handleTabChange(1)}
                  fill={selectedTab == 1 && primary500}
                />
              </div>
            </div>
          </div>
          {/* filters */}
          {(location.pathname !== '/' || displayExtra) &&
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%' }}>
              <div style={{ alignSelf: 'center', marginTop: '15px', marginRight: '15px' }}>
                <TextField
                  search={true}
                  value={searchTerm}
                  placeholder="Search for appliance"
                  background="light"
                  onChange={handleSearchTermChange}
                />
              </div>
              <div style={{ display: 'flex' }}>
                {selectedTab === 1 &&
                  // individual appliances
                  <Dropdown
                    label={'Filter By'}
                    size={200}
                    background="light"
                    list={['Savings', 'Appliance Type', 'Name', 'On/Off Status', 'WiFi Status']}
                    value={outletListFilter}
                    onSelect={selectOutletFilterPress}
                    isDropdownOpen={outletListDropdownOpen}
                    setIsDropdownOpen={setOutletListDropdownOpen}
                    hideIcon={true}
                  />
                }
                {selectedTab === 0 &&
                  //appliance types
                  <Dropdown
                    label={'Filter By'}
                    size={200}
                    background="light"
                    list={['Savings', 'Appliance Type', 'Number of Devices']}
                    value={applianceTypeFilter}
                    onSelect={selectApplianceFilterPress}
                    isDropdownOpen={applianceTypeFilterDropdown}
                    setIsDropdownOpen={setApplianceTypeFilterDropdown}
                    hideIcon={true}
                  />
                }
                <div style={{ alignSelf: 'center', marginTop: '10px', marginLeft: '10px' }}>
                  {filterDirection === 'Desc' &&
                    <IconButton
                      iconName={'arrow-down-1'}
                      tone="light"
                      size={30}
                      onClick={() => setFilterDirection('Asc')}
                    />
                  }
                  {filterDirection === 'Asc' &&
                    <IconButton
                      iconName={'arrow-up-1'}
                      tone="light"
                      size={30}
                      onClick={() => setFilterDirection('Desc')}
                    />
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <div style={{
          display: "flex",
          flexDirection: "column",
          height: height,
          overflowY: "scroll",
          alignItems: "center",
          width: "100%",
        }}>
          {filterLoading ? (
            <div style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "50px",
            }}>
              <CircularProgress />
            </div>
          ) : selectedTab === 1 ? (
            // NOTE: Switch this to flatList
            orderedOutlets.length > 0 ? (
              orderedOutlets.map((outlet, i) => {

                return (
                  <OutletCard
                    key={`${outlet.id}${i}`}
                    outlet={outlet}
                    handleRowClick={handleRowClick}
                    i={i}
                    width={width}
                    displayExtra={displayExtra}
                  />
                );
              })
            ) : (
              <div
                className="headlineMedium"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  marginTop: "50px",
                  color: "#999999",
                }}
              >
                No appliances available
              </div>
            )
          ) : (
            <ApplianceTypeList
              layoutProps={layoutProps}
              height={height}
              width={width}
              buildingOutlets={buildingOutlets ? buildingOutlets : []}
              buildingID={buildingID}
              applianceTypeFilter={applianceTypeFilter}
              filterDirection={filterDirection}
              displayExtra={displayExtra}
              searchTerm={searchTerm}
            />
          )}
        </div>
      </div>
      {/* modal */}
      <ApplianceDetailsScreen
        outlet={currentOutlet}
        setCurrentOutlet={setCurrentOutlet}
        open={isModalOpen}
        handleClose={closeModal}
      />
    </>
  );
}